import React, { useState, useEffect } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import BillPassingHoModal from "../components/billPassingHoModal";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const AddBillPassing = () => {
  useAuthRedirect();
  const { fld_purnumber } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); 
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [grnNo, setGrnNo] = useState(null);  
const [freight, setFreight] = useState(""); 
const [poNumber, setPoNo] = useState(""); 
const [subDetails, setSubDetails] = useState({})
const [hoDetails, setHoDetails] = useState({})
const [formData, setFormData] = useState({})
const navigate = useNavigate();

const canEntry = hasPermission("Bill Passing Menu - HO", "entry");

useEffect(() => {
  const fetchPoNo = async () => {
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchase_no`);
      if (response.data.PoNo) {
        const NewPo = parseInt(response.data.PoNo, 10) || 0;
        setPoNo(NewPo.toString());
        setFormData(prevState => ({ ...prevState, PoNumber: NewPo.toString() }));
      }
    } catch (error) {
      console.error("Error fetching indent number:", error);
    }
  };
  fetchPoNo();
}, []);

const handleSelectItem = async (supplier) => {
  try {
    setGrnNo(supplier.GRNHeader_Number); 

    const response = await axios.get("https://rfs2.infraconsoft.net.in/api/billHo_fetchData", {
      params: {
        grnNo: supplier.GRNHeader_Number,
      },
    });

    if (response.data.length > 0) {
      setSelectedItems(response.data);
    }
  } catch (error) {
    console.error("Error fetching supplier items:", error);
  }
};


// useEffect(() => {
//   const fetchFreightCharges = async () => {
//     if (!priNumber) return; // Skip fetching if priNumber is not set

//     try {
//       const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_fetchFrights?prNo=${priNumber}`);
//       const items = response.data.fetchFright;

//       if (items.length > 0) {
//         setFreight(items[0].freight_charges ||); 
//       }
//       console.log(response.data.fetchFright);
      
//     } catch (error) {
//       console.error("Error fetching freight charges:", error);
//     }
//   };

//   fetchFreightCharges();
// }, [priNumber]); 

useEffect(() => {
    const fetchBillPassingHeader = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/billHo_fetchHeader?grnNo=${grnNo}`);
            const items = response.data.headerDetails;
            console.log(response.data.headerDetails);
            
            const hoHeader = {
                grnHeaderNo: items[0].grnheader_number,
                grnDate : items[0].grnheader_date,
                poNo: items[0].GrnHeader_poNumber,
                poDate : items[0].GrnHeader_poDate,
                fright: items[0].grnHeader_freightCharges,
                transport : items[0].grnHeader_transport ,
                paymentTerms : items[0].grnHeader_paymentTerms,
                delMethod : items[0].grnHeader_deliveryMethod,
                delPlace : items[0].grnHeader_deliveryPlace,
                remarks : items[0].grnHeader_remarks,
                priceBasis : items[0].grnHeader_priceBasis,
                supplierNo : items[0].grnheader_suppliercode,
                dcNo : items[0].grnheader_DcNumber,
                dcDate : items[0].grnheader_DcDate,
                invoiceNo : items[0].grnheader_invoiceNumber,
                invoiceDate : items[0].grnheader_invoiceDate,
                
            };
            setHoDetails(hoHeader);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchBillPassingHeader();
  }, [grnNo]); 


useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${hoDetails.supplierNo}`);
            const items = response.data.supDetails;
            console.log(response.data.supDetails);
            
            const storeReqHeader1 = {
                supplierMaster_code: items[0].supplierMaster_code,
                supplierMaster_name: items[0].supplierMaster_name,
                supplierMaster_addressline1 : items[0].supplierMaster_addressline1,
                supplierMaster_addressline2 : items[0].supplierMaster_addressline2,
                supplierMaster_city : items[0].supplierMaster_city,
                supplierMaster_pincode : items[0].supplierMaster_pincode,
                
            };
            setSubDetails(storeReqHeader1);
            // setData(response.data.supDetails);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [hoDetails.supplierNo]); 


  // Calculate totals
  const totals = selectedItems.reduce(
    (acc, item) => {
        const itemValue = item.grnDetail_acceptedQuantity * item.grnDetail_price; 
        const discountValue = itemValue * (item.grnDetail_discountPercentage / 100);
        const pfValue = itemValue * (item.grnDetail_pfPercentage / 100);
        const taxValue = itemValue * (item.grnDetail_taxPercentage / 100);
        const totalValue = itemValue + taxValue + pfValue - discountValue;

        acc.itemValue = itemValue;
      acc.totalItemValue += itemValue;
      acc.totalDiscValue += discountValue;
      acc.totalTaxValue += taxValue;
      acc.totalPfValue += pfValue;
      acc.grandTotalValue += totalValue ;

      return acc;
    },
    {
      totalItemValue: 0,
      totalDiscValue: 0,
      totalTaxValue: 0,
      totalPfValue: 0,
      grandTotalValue: 0,
    }
  );

  const freightAmount = isNaN(parseFloat(hoDetails.fright)) ? 0.00 : parseFloat(hoDetails.fright);
  const finalTotal = totals.grandTotalValue + freightAmount;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedItems.length === 0) {
        Swal.fire("Error", "Please add at least one item", "error");
        return;
    }

    const payload = {
        grnNo : hoDetails.grnHeaderNo,
        grnDate : hoDetails.grnDate,
        branch: branch,
        poNo: hoDetails.poNo,
        poDate: hoDetails.poDate,
        user: user,
        scode: subDetails.supplierMaster_code,
        dcNo : hoDetails.dcNo,
        dcDate : hoDetails.dcDate,
        invoiceNo : hoDetails.invoiceNo,
        invoiceDate : hoDetails.invoiceDate,
        accValue: totals.itemValue,
        paymentTerms: hoDetails.paymentTerms,
        transport: hoDetails.transport,
        fright: hoDetails.fright,
        delMethod: hoDetails.delMethod,
        delPlace: hoDetails.delPlace,
        totValue : finalTotal.toFixed(2),
        remarks: hoDetails.remarks,
        priceBasis: hoDetails.priceBasis,
        subValue : totals.totalItemValue.toFixed(2),
        pf: totals.totalPfValue.toFixed(2),
        disc: totals.totalDiscValue.toFixed(2),
        gst: totals.totalTaxValue.toFixed(2),
        
        items: selectedItems.map((item) => {
            const itemValue = item.grnDetail_acceptedQuantity * item.grnDetail_price; 
            const discountValue = itemValue * (item.grnDetail_discountPercentage / 100);
            const pfValue = itemValue * (item.grnDetail_pfPercentage / 100);
            const taxValue = itemValue * (item.grnDetail_taxPercentage / 100);
            const totalValue = itemValue + taxValue + pfValue - discountValue;

            return {
                itemName: item.itemMaster_Name,
                itemCode: item.grnDetail_itemcode,
                itemName: item.grnDetail_itemName,
                itemUom: item.grnDetail_uom,
                qty: item.grnDetail_poPendingQuantity,
                price: item.grnDetail_price,
                accQty: item.grnDetail_acceptedQuantity,
                rejQty: item.grnDetail_rejectedQuantity,
                cst: item.grnDetail_taxPercentage,
                pf: item.grnDetail_pfPercentage,
                disc: item.grnDetail_discountPercentage,
                value: totalValue.toFixed(2), 
            };
        }),
    };

    console.log(payload);

    try {
         Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

        const response = await axios.post("https://rfs2.infraconsoft.net.in/api/billHo_insert", payload);
        Swal.fire("Success", "Bill Passing successfully", "success");
        // alert("Success");
        setSelectedItems([]);
        navigate('/inventory/billPassingGRNView');
    } catch (error) {
        console.error("Error submitting form:", error);
        Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
};

if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                                  <h2 className="add-txt">Bill Passing HO</h2>
                                  <Link to='/inventory/billPassingGRNView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                  </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
              <div className="form-group">
                <label>GRN No :</label>
                <input type="text" name="PoNumber" value={hoDetails.grnHeaderNo} readOnly />
              </div>
              <div className="form-group">
                <label>GRN Date :</label>
                <input type="text" name="yourRefDate" value={new Date(hoDetails.grnDate).toLocaleDateString('en-GB')}  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>P.O No :</label>
                <input type="text" name="PoNumber" value={hoDetails.poNo} readOnly />
              </div>
              <div className="form-group">
                <label>P.O Date :</label>
                <input type="text" name="yourRefDate" value={new Date(hoDetails.poDate).toLocaleDateString('en-GB')}  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={subDetails.supplierMaster_code} />
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={subDetails.supplierMaster_name}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>D.C No :</label>
                <input type="text" name="yourRefNo" value={hoDetails.dcNo}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>D.C Date :</label>
                <input type="text" name="yourRefDate" value={new Date(hoDetails.dcDate).toLocaleDateString('en-GB')}  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Invoice No :</label>
                <input type="text" name="ourRefNo" value={hoDetails.invoiceNo}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Invoice Date :</label>
                <input type="text" name="yourRefDate" value={new Date(hoDetails.invoiceDate).toLocaleDateString('en-GB')}  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1"value={subDetails.supplierMaster_addressline1} />
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="address2" value={subDetails.supplierMaster_addressline2}/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city"value={subDetails.supplierMaster_city} />
              </div>
              <div className="form-group">
                <label>Pin Code :</label>
                <input type="text" name="pincode" value={subDetails.supplierMaster_pincode}/>
              </div>
            </div>


            <div className="flex_buttons">
              <button type="button" className="button button-add" onClick={() => setShowModal(true)}>
                Add Item
              </button>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>GRN Qty</th>
                    <th>Acc. Qty</th>
                    <th>Rej. Qty</th>
                    <th>Price</th>
                    <th>GST%</th>
                    <th>P&F%</th>
                    <th>Disc%</th>
                    <th>Value</th>
                    <th>Bill Passing By</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedItems.length > 0 ? (
                    selectedItems.map((item, index) => {
                      const itemValue = item.grnDetail_acceptedQuantity * item.grnDetail_price; 
                      const discountValue = itemValue * (item.grnDetail_discountPercentage / 100);
                      const pfValue = itemValue * (item.grnDetail_pfPercentage / 100);
                      const taxValue = itemValue * (item.grnDetail_taxPercentage / 100);
                      const totalValue = itemValue + taxValue + pfValue - discountValue;

                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.grnDetail_itemcode}</td>
                          <td>{item.grnDetail_itemName}</td>
                          <td>{item.grnDetail_uom}</td>
                          <td>{item.grnDetail_poPendingQuantity}</td>
                          <td>{item.grnDetail_acceptedQuantity}</td>
                          <td>{item.grnDetail_rejectedQuantity}</td>
                          <td>{item.grnDetail_price}</td>
                          <td>{item.grnDetail_taxPercentage}</td>
                          <td>{item.grnDetail_pfPercentage}</td>
                          <td>{item.grnDetail_discountPercentage}</td>
                          <td>{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totalValue)}</td>
                          <td>{user}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10">No items added</td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Billing Summary */}
              <div className="po-bill-container">
                <h2 className="po-bill-title">Billing Summary</h2>
                <div className="po-bill-summary">
                  <div className="po-bill-item">
                    <span className="po-bill-label">Sub Total:</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalItemValue)}</span>
                  </div>

                   <div className="po-bill-item">
                    <span className="po-bill-label">GST (%):</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalTaxValue)}</span>
                  </div>

                     <div className="po-bill-item">
                    <span className="po-bill-label">PF:</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalPfValue)}</span>
                  </div>

                   <div className="po-bill-item">
                    <span className="po-bill-label">Disc (%):</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalDiscValue)}</span>
                  </div>

               
                  
                 
                 

                  <div className="po-bill-item">
                    <span className="po-bill-label">Freight Charges:</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(hoDetails.fright)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Transport:</span>
                    <span className="po-bill-value">{hoDetails.transport}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Payment Terms:</span>
                    <span className="po-bill-value">{hoDetails.paymentTerms}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Delivery Method:</span>
                    <span className="po-bill-value">{hoDetails.delMethod}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Delivery Place:</span>
                    <span className="po-bill-value">{hoDetails.delPlace}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Price Basis:</span>
                    <span className="po-bill-value">{hoDetails.priceBasis}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Remarks:</span>
                    <span className="po-bill-value">{hoDetails.remarks}</span>
                  </div>
                  <div className="po-bill-item po-bill-total">
                    <span className="po-bill-label">Total:</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(finalTotal)}</span>
                  </div>

                </div>
              </div>


            </div>
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>
          </form>
        </div>
      </div>

      <BillPassingHoModal showModal={showModal} closeModal={() => setShowModal(false)} branch={branch} onSelectItem={handleSelectItem} />
    </div>
  );
};

export default AddBillPassing;
